import "./module/userAgentChecker.min.js"
import "./module/plugin.js"
import "./module/modal-multi.js"

//商品Slide
import Swiper from 'swiper/bundle';
var myswiper01 = new Swiper('.swiper-container');

// slideToメソッドを実行する関数を定義

document.querySelectorAll(".single__innerFigThumSlideInner").forEach((node, i) => {
  node.addEventListener("click", () => {
    myswiper01.slideTo(i);
  })
})

//マウスカーソルパララックス
import Parallax from 'parallax-js'
var scene = document.getElementById('scene');
var parallax = new Parallax(scene);

//慣性イージング
import luxy from 'luxy.js'
var _ua = (function (u) {
  return {
    Tablet: (u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1) ||
      u.indexOf("ipad") != -1 ||
      (u.indexOf("android") != -1 && u.indexOf("mobile") == -1) ||
      (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1) ||
      u.indexOf("kindle") != -1 ||
      u.indexOf("silk") != -1 ||
      u.indexOf("playbook") != -1,
    Mobile: (u.indexOf("windows") != -1 && u.indexOf("phone") != -1) ||
      u.indexOf("iphone") != -1 ||
      u.indexOf("ipod") != -1 ||
      (u.indexOf("android") != -1 && u.indexOf("mobile") != -1) ||
      (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1) ||
      u.indexOf("blackberry") != -1
  }
})(window.navigator.userAgent.toLowerCase());

if (!_ua.Mobile && !_ua.Tablet) {
  luxy.init({
    wrapper: '#scroll',
    targets: '.parallax',
    wrapperSpeed: 0.085
  });
}

import ScrollMagic from 'scrollmagic';
//スクロールアニメーション
class ScrollFade {
  constructor() {
    this.ANIMATION_CLASS = 'is_fire';

    let $section = document.querySelectorAll('.anim:not(.is_fire)');
    if ($section.length === null) {
      return;
    }
    let controller = new ScrollMagic.Controller();
    for (let i = 0; i < $section.length; i++) {
      let scene = new ScrollMagic.Scene({
          triggerElement: $section[i],
          triggerHook: 'onEnter',
          reverse: false,
          offset: 100
        })
        .addTo(controller);
      scene.on('enter', () => {
        $section[i].classList.add(this.ANIMATION_CLASS);
      });
      scene.on('end', () => {
        scene.destroy(true);
      });
    }
  }
}

new ScrollFade();

//spanタグ挿入
class SpanWrap {
  constructor() {
    this.settings = {
      target: ".animSpan"
    }
    this.targets = "";
    this.targetLength = 0;
    this.nodes = [];
    this.convertContents = [];
  }

  init(options) {
    this.setup(options);
    this.getNodes();
    this.convert();
    this.set();
    console.log("animeSpan")
  }

  setup(options) {
    this.settings = Object.assign({
      target: this.settings.target
    }, options || {});
    this.targets = document.querySelectorAll(this.settings.target);
    this.targetLength = this.targets.length;
  }

  getNodes() {
    for (let target of this.targets) {
      let nodes = target.childNodes;
      this.nodes.push(nodes);
    }
  }

  convert() {
    for (let i = 0; i < this.targetLength; i++) {
      this.convertContents.push([]); //カラの配列を追加
      for (let node of this.nodes[i]) {
        if (node.nodeType == 3) { //テキストの場合
          let text = node.textContent.replace(/\s+/g, ''); //テキストから空白削除
          text.split('').forEach((v) => {
            this.convertContents[i].push("<span>" + v + "</span>");
          });

        } else { //テキスト以外
          this.convertContents[i].push(node.outerHTML);
        }
      }
    }
  }

  set() {
    for (let i = 0; i < this.targetLength; i++) {
      this.targets[i].innerHTML = this.convertContents[i].join("");
    }
  }

}

const spanWrap = new SpanWrap();
spanWrap.init();

require('./module/ofi.min.js');

(function (d) {
  var config = {
      kitId: 'edq2jzv',
      scriptTimeout: 3000,
      async: true
    },
    h = d.documentElement,
    t = setTimeout(function () {
      h.className = h.className.replace(/\bwf-loading\b/g, "") + " wf-inactive";
    }, config.scriptTimeout),
    tk = d.createElement("script"),
    f = false,
    s = d.getElementsByTagName("script")[0],
    a;
  h.className += " wf-loading";
  tk.src = 'https://use.typekit.net/' + config.kitId + '.js';
  tk.async = true;
  tk.onload = tk.onreadystatechange = function () {
    a = this.readyState;
    if (f || a && a != "complete" && a != "loaded") return;
    f = true;
    clearTimeout(t);
    try {
      Typekit.load(config)
    } catch (e) {}
  };
  s.parentNode.insertBefore(tk, s)
})(document);

import objectFitImages from 'object-fit-images';
objectFitImages();